<ngx-loading [show]="loadingIndicator"></ngx-loading>
<div class="row pt-0 pl-0">
    <div class="col-md-12">
        <button type="button" class="btn btn-secondary btn-sm mb-1 mr-1" aria-expanded="false"
            (click)="openPromptModalTask(modalTaskForm, null)" placement="bottom" ngbTooltip="Add Task">
            <span class="sr-only">Add Task</span>
            <i class="fa fa-lg fa-plus"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp;Add Task</span>
        </button>
        <button type="button" class="btn btn-sm btn-secondary dropdown-toggle mb-1 mr-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" placement="bottom" ngbTooltip="Hide/Show Columns">
            <span class="sr-only">Toggle Dropdown</span>
            <i class="fa fa-lg fa-check-square-o"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Columns</span>
        </button>
        <div class="dropdown-menu" align="bottom">
            <div class="row">
                <div class="col-12">
                    <div class="card-body">
                        <input type="checkbox" name="assigned_to"  [(ngModel)]="show_assigned_to"> Assigned To<br />   
                        <input type="checkbox" name="title"  [(ngModel)]="show_title"> Title<br />
                        <input type="checkbox" name="category"  [(ngModel)]="show_category"> Category<br />   
                        <input type="checkbox" name="status"  [(ngModel)]="show_status"> Status<br />   
                        <input type="checkbox" name="date_due"  [(ngModel)]="show_date_due"> Date Due<br />   
                        <input type="checkbox" name="notes"  [(ngModel)]="show_notes"> Notes<br />   
                        <input type="checkbox" name="percentage_done"  [(ngModel)]="show_percent_done"> Percentage Done<br />   
                        <input type="checkbox" name="created_date"  [(ngModel)]="show_created_date"> Created Date<br />
                        <input type="checkbox" name="updated_date"  [(ngModel)]="show_updated_date"> Updated Date<br />
                        <input type="checkbox" name="viewed_at"  [(ngModel)]="show_viewed_date"> Viewed Date<br />
                        <input type="checkbox" name="viewed_at"  [(ngModel)]="show_file"> File<br />
                    </div>
                </div>
            </div>
        </div>
        <button type="button" [ngClass]="(showFilters)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1"
            (click)="toggleFilters()" placement="bottom" ngbTooltip="Filter List">
            <i class="fa fa-lg fa-filter"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp;Filter</span>
        </button>
        <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1" (click)="print()" [disabled]="count_tasks < 1" placement="bottom" ngbTooltip="Print List">
            <i class="fa fa-lg fa-print"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp;Print</span>
        </button>
        <div class="btn-group">
           <button type="button" class="btn btn-sm btn-secondary dropdown-toggle mb-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [disabled]="count_tasks < 1" placement="bottom" ngbTooltip="Export List">
            <i class="fa fa-lg fa-download"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp;Export</span>
            </button>
            <div class="dropdown-menu">
                <a (click)="exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to CSV</a> 
                <a (click)="exportToExcel()" class="dropdown-item" href="javascript:void(0);">Export to Excel</a> 
                <a (click)="exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to PDF</a> 
            </div>
        </div>
    </div>
</div>
<br *ngIf="showFilters" />
<div class="row-md-12 pt-0">
<div class="col-md-12">
    <div widget class="card border-0 box-shadow" *ngIf="showFilters">
        <div class="card-header border-0 text-muted">
            <h5 class="mb-0">Search Tasks List:</h5>
            <div class="widget-controls"> 
                <a data-widgster="close"class="transition" (click)="toggleFilters()"><i class="fa fa-times"></i></a>
            </div>  
        </div>
        <div class="card-block card-header pt-0 widget-body">
            <div class="row">
                <div class="form-group col-md-3">
                    <label>Assigned To:</label> 
                    <input type="text" class="form-control form-control-sm" (keyup)="updateFilter()" [(ngModel)]="filter_assigned_to">
                </div>
                <div class="form-group col-md-3">
                    <label>Title:</label> 
                    <input type="text" class="form-control form-control-sm" (keyup)="updateFilter()" [(ngModel)]="filter_title">
                </div>
                <div class="form-group col-md-3">
                    <label>Status:</label><br />
                    <select placeholder="Select" [(ngModel)]="filter_status" (change)="updateFilter()"  style="width:100%"> 
                        <option selected disabled>Select..</option>
                        <option *ngFor="let s of statuses" value="{{s.name}}">{{s.name}}</option>
                    </select>
                </div>
                <div class="form-group col-md-3">
                    <label>Category:</label><br />
                    <select placeholder="Select" [(ngModel)]="filter_category" (change)="updateFilter()"  style="width:100%">
                        <option selected disabled>Select..</option>
                        <option *ngFor="let c of categories" value="{{c.name}}">{{c.name}}</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-md-4">
                    <label>Due Date:</label>&nbsp; 
                    From &nbsp;<input type="date" class="form-control form-control-sm" [(ngModel)]="filter_due_fr"> &nbsp; 
                </div>
                <div class="form-group col-md-4">
                    <label>To &nbsp;</label>&nbsp;
                    <input type="date" class="form-control form-control-sm" (change)="updateFilter()" [(ngModel)]="filter_due_to" [disabled]="!filter_due_fr">
                </div>
                
            </div>
            <div class="row" *ngIf="!isFilterEmpty">
                <div class="col-md-12">
                    <button  type="button" class="btn btn-success btn-sm mb-1" (click)="resetFilters()">
                        <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-filter"></i></span>
                        <span >Reset Filters</span>
                    </button> &nbsp;
                </div>
            </div>                                  
        </div>
    </div>
</div>
</div>
<br *ngIf="showFilters" />
<br />
<div *ngIf="count_tasks > 0" class="row pt-0">
<div class="col-md-12">
    <span class="badge badge-pill badge-completed pull-right">Completed</span>
    <span class="badge badge-pill badge-processing pull-right">Processing</span>
    <span class="badge badge-pill badge-pending pull-right">Pending</span>
</div>


</div>
<div class="row pt-2">
<div class="col-md-12">
    <ngx-datatable
        [loadingIndicator]="loadingIndicator"
        class="material"
        [rows]="rows"
        [columnMode]="'force'"
        [columns]="columns"
        [footerHeight]="40"
        [rowHeight]="'auto'"
        [limit]="20"
        [selected]="selected"
        [selectionType]="'single'"
        (activate)="onActivate($event)"
        (select)='onSelect($event)'
        [scrollbarH]="true">

        <ngx-datatable-column prop="id" name="Operations" headerClass="header" [width]="70"  [cellClass]="getCellClass"> 
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <div align="left" style="padding-right:20px">  
                    <a class="cursorhover" title="Edit" (click)="openPromptModalTask(modalTaskForm,selected[0])"><i class="fa  fa-lg fa-pencil"></i>&nbsp;</a>
                    <a class="cursorhover" title="Delete Task" (click)="openDeleteTaskModal(selected[0])"><i class="fa fa-lg fa-trash"></i></a>
                </div>
            </ng-template>
        </ngx-datatable-column>    
        <ngx-datatable-column name="Assigned To" prop="assigned_to_name"  headerClass="header" [width]="120"  [cellClass]="getCellClass" *ngIf="show_assigned_to">
            <ng-template let-row="row" ngx-datatable-cell-template *ngIf="show_assigned_to">
                <label>{{row.assigned_to_name}}</label>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Title" prop="title"  headerClass="header" [width]="220" [cellClass]="getCellClass" *ngIf="show_title"></ngx-datatable-column>
        <ngx-datatable-column name="Category" prop="category_name"  headerClass="header" [width]="120" [cellClass]="getCellClass" *ngIf="show_category"></ngx-datatable-column>
        <ngx-datatable-column name="Status" prop="status_name"  headerClass="header" [width]="120" [cellClass]="getCellClass" *ngIf="show_status"></ngx-datatable-column>
        <ngx-datatable-column name="File" prop="file"  headerClass="header" [width]="215" [cellClass]="getCellClass" *ngIf="show_file">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                        <a href="{{folderTaskPath}}{{value}}" target="_new">{{value}}</a>
                    </ng-template>
                </ngx-datatable-column>
        <ngx-datatable-column name="Notes" prop="notes"  headerClass="header" [width]="120"  [cellClass]="getCellClass" *ngIf="show_notes"></ngx-datatable-column>
        <ngx-datatable-column name="Date Due" prop="date_due"  headerClass="header" [width]="120" [cellClass]="getCellClass" *ngIf="show_date_due">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <span class="urgent" *ngIf="row.is_urgent == 1"><i class="fa fa-warning"></i></span>
                <label>{{ (row.date_due !== null && row.date_due !== '0000-00-00') ? (formatDate(row.date_due) | date: 'dd MMM yyyy') : "No Date"  }}</label>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Percentage Done (%)" prop="percent_done"  headerClass="header" [width]="150" [cellClass]="getCellClass" *ngIf="show_percent_done">
            <ng-template let-value="value" ngx-datatable-cell-template>
                {{ value == null ? 0 : value  }} 
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Created Date" prop="created_at"  headerClass="header" [width]="120" [cellClass]="getCellClass" *ngIf="show_created_date">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{ (row.created_at !== null && row.created_at !== '0000-00-00') ? (formatDate(row.created_at) | date: 'dd MMM yyyy') : "No Date"  }}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Last Viewed Date" prop="viewed_at"  headerClass="header" [width]="120" [cellClass]="getCellClass" *ngIf="show_viewed_date">
            <ng-template let-value="value" ngx-datatable-cell-template>
                {{ (value != null && value != '0000-00-00 00:00:00') ? (value | date: 'dd MMM yyyy , h:mm a') : "No Date"  }} 
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Last Updated Date" prop="updated_at"  headerClass="header" [width]="120" [cellClass]="getCellClass" *ngIf="show_updated_date">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{ (row.updated_at != null && row.updated_at != '0000-00-00') ? (formatDate(row.updated_at) | date: 'dd MMM yyyy') : "No Date"  }}
            </ng-template>
        </ngx-datatable-column>
        
    </ngx-datatable>
</div>
</div>

<!-- START OF DELETE TASK FORM -->
<ng-template #modalDeleteTask let-close="close">
<div class="modal-header">
<h5 class="modal-title">Delete Task</h5>
<button type="button" class="close" (click)="close()">
    <span aria-hidden="true">&times;</span>
</button>
</div>
<div class="modal-body">
<div class="row">
    <div class="col-md-12">
       Do you really want to delete <b>{{task.title}}</b>?
    </div>
</div>
</div>
<div class="modal-footer"><i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
<button type="button" class="btn btn-sm btn-danger"  (click)="deleteTask(task.id)"  [disabled]="spinner == true">Delete</button>
<button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
</div>
</ng-template>
<!-- END OF MODAL DELETE TASK FORM -->

<!-- START PRINT-->
<div id="print-section" style="display:none">
<table style="width:100%">
<tr>
  <th align="left" *ngIf="show_assigned_to">ASSIGNED TO</th>
  <th align="left" *ngIf="show_title">TITLE</th>
  <th align="left" *ngIf="show_category">CATEGORY</th>
  <th align="left" *ngIf="show_status">STATUS</th>
  <th align="left" *ngIf="show_file">FILE</th>
  <th align="left" *ngIf="show_notes">NOTES</th>
  <th align="left" *ngIf="show_date_due">DUE DATE</th>
  <th align="left" *ngIf="show_percent_done">PERCENTAGE DONE (%)</th>
  <th align="left" *ngIf="show_created_date">CREATED AT</th>
  <th align="left" *ngIf="show_viewed_date">LAST VIEWED AT</th>
  <th align="left" *ngIf="show_updated_date">LAST UPDATED</th>
</tr>
<tr *ngFor="let row of rows">
  <td *ngIf="show_assigned_to">{{row.assigned_to_name}}</td>
  <td *ngIf="show_title">{{row.title}}</td>
  <td *ngIf="show_category">{{row.category_name}}</td>
  <td *ngIf="show_status">{{row.status_name}}</td>
  <td *ngIf="show_file">{{row.file}}</td>
  <td *ngIf="show_notes">{{row.notes}}</td>
  <td *ngIf="show_date_due"><span class="urgent" *ngIf="row.is_urgent == 1"><i class="fa fa-warning"></i></span><label>{{(row.date_due != null && row.date_due != '0000-00-00') ? (formatDate(row.date_due) | date: 'dd MMM yyyy') : "No Date"  }}</label></td>
  <td *ngIf="show_percent_done">{{row.percent_done}}</td>
  <td *ngIf="show_created_date">{{ (row.created_at != null && row.created_at != '0000-00-00') ? (formatDate(row.created_at) | date: 'dd MMM yyyy') : "No Date"  }}</td>
  <td *ngIf="show_viewed_date">{{ (row.viewed_at != null && row.viewed_at != '0000-00-00 00:00:00') ? (row.viewed_at | date: 'dd MMM yyyy, h:mm a') : "No Date"  }}</td>
  <td *ngIf="show_updated_date">{{ (row.updated_at != null && row.updated_at != '0000-00-00') ? (formatDate(row.updated_at) | date: 'dd MMM yyyy') : "No Date"  }}</td>
</tr>
</table>
</div>
<!-- END PRINT -->

<!-- START OF TASK MODAL FORM -->
<ng-template #modalTaskForm let-close="close">
<div class="modal-header">
<h5 class="modal-title" *ngIf="isEditMode==false">Add New Task</h5>
<h5 class="modal-title" *ngIf="isEditMode==true">Edit Task</h5>
<button type="button" class="close" (click)="close()">
    <span aria-hidden="true">&times;</span>
</button>
</div>
<app-addupdatetask [task]="task ? task : null" [caller]="prefixTask" [objectId]="null" (closeModal)="closeModal()"></app-addupdatetask>
</ng-template>
<!-- END OF TASK MODAL FORM -->
